import { Attachment as GQLItem } from '../../../generated/api.graphql';

export type Attachment = {
  id: number;
  name: string;
  url?: string;
};

export const fromGql = (item: GQLItem): Attachment => ({
  id: item.id,
  name: item.name,
  url: item.url ?? undefined,
});
